import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-add-domain-zone-limit-exceeded',
    templateUrl: './add-domain-zone-limit-exceeded.component.html',
    styleUrls: ['./add-domain-zone-limit-exceeded.component.scss'],
    standalone: false
})
export class AddDomainZoneLimitExceededComponent implements OnInit {

  @Input() domain?: string;
  @Input() ipv4Address?: string;
  @Input() zoneNotCreated?: boolean;
  public isCopied: any = [];

  constructor(
    public activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {

  }

  public copied(index: any) {
    this.isCopied[index] = true;
    setTimeout( () => this.isCopied[index] = false, 800);
  }

}
